import { BaseCart, SimpleEvent } from '@eastsideco/salvo-ts';

export default class Cart extends BaseCart {
    private _onChangeByInteraction = new SimpleEvent<void>();
    public get onChangeByInteraction() {
        return this._onChangeByInteraction.asEvent();
    }

    constructor() {
        super();
    }

    /**
     * Wrap actions performed on the cart as being in the context of a customer interaction.
     * Triggers `onChangeByInteraction`, which can be used to i.e. show add-to-cart feedback.
     */
    async asInteraction<T = void>(cb: () => T): Promise<T> {
        // eslint-disable-next-line @typescript-eslint/await-thenable
        const r = await cb();
        this._onChangeByInteraction.dispatch();
        return r;
    }


    isEmpty() {
        return cart.items.length <= 0;
    }

    getCartItemCount() {
        let itemCount = 0;
        for (const item of cart.items) {
            itemCount += item.quantity;
        }
        return itemCount;
    }
}

export const cart = new Cart();

cart.reload().catch((event: unknown | null) => {
    if (event instanceof Error) {
        // this.$log.error(event.message);
    }
});
